module.exports = __webpack_public_path__ + "static/media/ac-presence.cf752ac3.svg";